import React from "react";
import { MousePointerClick, CalendarCheck, Car } from "lucide-react";

const steps = [
  {
    icon: MousePointerClick,
    title: "Pick your service",
    desc: "Choose from exterior, interior, or the full detail.",
  },
  {
    icon: CalendarCheck,
    title: "Choose a time",
    desc: "Lock in a date that works — we'll confirm by text.",
  },
  {
    icon: Car,
    title: "We pull up & shine",
    desc: "We arrive on time, fully equipped, and leave your car looking new.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* 3-Step Booking Process */}
        <div data-testid="booking-steps">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <div className="text-xs uppercase tracking-[0.3em] text-[#4B0082] font-semibold mb-4">
              How it works
            </div>
            <h3 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-slate-900 leading-tight">
              Booked in three easy steps.
            </h3>
          </div>

          <div className="grid md:grid-cols-3 gap-6 lg:gap-8 relative">
            {/* Connecting line behind steps on desktop */}
            <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#4B0082]/30 to-transparent" />

            {steps.map((s, i) => (
              <div
                key={i}
                data-testid={`step-${i}`}
                className="relative bg-white border border-slate-200 rounded-xl p-8 hover:border-[#4B0082]/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-20 h-20 rounded-full bg-[#F3E8FF] flex items-center justify-center relative">
                    <s.icon className="w-7 h-7 text-[#4B0082]" />
                    <div className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-[#4B0082] text-white font-heading font-bold text-sm flex items-center justify-center shadow-md">
                      {i + 1}
                    </div>
                  </div>
                </div>
                <h4 className="font-heading font-bold text-xl text-slate-900 mb-2">
                  {s.title}
                </h4>
                <p className="text-slate-600 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
